import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { Card, Container, SectionLabel } from '../../design';
import { CtaBand } from './CtaBand';
import { PortContainer, Spot } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { DOC_CHIPS, ENTRY, FLAGS, SAMBAR_LINES } from './ProductLandedCostPage.data';
import { NextLink, ProductDetails, ProductFaq, ProductHero, ProductSection, ProductStep, ProductSteps } from './ProductParts';
import './product-landed-cost.css';
// Ported from design-mockups/rhd-woodblock/Product-Landed-Cost.dc.html. Copy differs only where
// the design described something the cost ledger doesn't do (splitting, emailed documents,
// a CBP-rate fallback, a document cross-checking feature).
export default function ProductLandedCostPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('landed-cost'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    align: "start",
                    k: "原価",
                    label: "Product · 06 Landed cost",
                    title: "Your real landed cost, from your own paperwork.",
                    lead: "Drop in the stack of PDFs. The app pulls out each line for you to check, adds them up per car and links every one to the document it came from. There are no made-up “standard” costs in it.",
                    copyStyle: {
                        flexBasis: 360
                    },
                    children: /*#__PURE__*/ _jsxs(Card, {
                        shadow: "lg",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-landed__sheet-head",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-landed__sheet-car",
                                        children: "2001 Subaru Sambar · real import"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-landed__sheet-frame",
                                        children: "TT2-104086"
                                    })
                                ]
                            }),
                            SAMBAR_LINES.map((l)=>/*#__PURE__*/ _jsxs("div", {
                                    className: "mk-landed__line",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-landed__line-label",
                                            children: l.label
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-landed__line-usd",
                                            children: l.usd
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-landed__line-note",
                                            children: l.note
                                        }),
                                        /*#__PURE__*/ _jsxs("a", {
                                            href: "#docs",
                                            className: "mk-landed__line-doc",
                                            children: [
                                                "↗ ",
                                                l.doc
                                            ]
                                        })
                                    ]
                                }, l.label)),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-landed__total",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-landed__total-label",
                                        children: "Landed so far"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "$7,085.16"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-landed__missing",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "○ Still missing: broker invoice, title receipt"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "○ No Wise transfer yet, so ¥ lines use the rate on the invoice"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 300,
                    children: /*#__PURE__*/ _jsx(PortContainer, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    id: "docs",
                    loose: true,
                    title: "Put in a pile of PDFs and get back one honest number.",
                    children: /*#__PURE__*/ _jsxs(ProductSteps, {
                        children: [
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "壱",
                                title: "Drag in the stack",
                                text: "Drop them all in at once. The app recognises each document and matches it to the right car by frame number.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-landed__drop",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "mk-landed__drop-note",
                                            children: "11 files dropped · 5 vehicles matched by frame number"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mk-landed__chips",
                                            children: DOC_CHIPS.map((c)=>/*#__PURE__*/ _jsxs("span", {
                                                    className: "mk-landed__chip",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "mk-landed__chip-k",
                                                            children: c.k
                                                        }),
                                                        c.name
                                                    ]
                                                }, c.name))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "弐",
                                title: "Review the lines it found",
                                text: "Nothing is booked until you’ve looked. Accept or edit each line, then apply. If you apply the same document again, its lines get replaced, so they never double up.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__review-head",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__review-title",
                                                    children: "CBP Form 7501 · line 1 of 5"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__review-frame",
                                                    children: "TT2-104086"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__review-row",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Duty · 8704.31.0120 · 25%"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$1,008.25"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__review-row",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "MPF · 499"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$13.97"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__review-row",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "HMF · 501"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$5.04"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "参",
                                title: "See what’s still missing",
                                text: "Each car has a checklist of the paperwork that hasn’t arrived yet, so you always know when a total is incomplete.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-landed__checklist",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__check",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                }),
                                                "Purchase · agent invoice"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__check",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                }),
                                                "Freight · agent invoice (RoRo)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__check",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__ok",
                                                    children: "✓"
                                                }),
                                                "Duty, MPF & HMF · CBP 7501"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__check mk-landed__check--missing",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "○"
                                                }),
                                                "No broker invoice yet"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__check mk-landed__check--missing",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "○"
                                                }),
                                                "No title receipt yet"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProductStep, {
                                k: "四",
                                title: "Record the sale, see the profit",
                                text: "Enter what it sold for. The profit on that car is the sale price minus a landed cost you can trace line by line.",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-pp-step__ui mk-pp-step__ui--framed mk-landed__sale",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__sale-row",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Sold · 1999 Stagea (example)"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$16,900.00"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__sale-row mk-landed__sale-row--muted",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Landed cost"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "− $12,534.92"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__sale-row mk-landed__sale-row--profit",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Profit on this car"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$4,365.08"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("section", {
                    "data-screen-label": "One entry, five cars",
                    className: "mk-landed__band mk-ground--shu",
                    children: /*#__PURE__*/ _jsxs(Container, {
                        className: "mk-landed__entry-inner",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-landed__entry-intro",
                                children: [
                                    /*#__PURE__*/ _jsx(SectionLabel, {
                                        k: "分配",
                                        children: "Real shipment · Aug 2026"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "mk-landed__h2",
                                        children: "One 7501, five vehicles, each car on its own line."
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mk-landed__body17",
                                        children: "This was a single RoRo entry into Los Angeles/Long Beach. Each car books only its own line, with duty, MPF and HMF worked from its entered value, and the five add up exactly to the entry totals."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Card, {
                                shadow: "md",
                                className: "mk-landed__table",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mk-landed__table-inner",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__tr mk-landed__tr--head",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Vehicle · frame no."
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Entered"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Rate"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Duty"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "MPF"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "HMF"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "Customs"
                                                })
                                            ]
                                        }),
                                        ENTRY.map((e)=>/*#__PURE__*/ _jsxs("div", {
                                                className: "mk-landed__tr",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "mk-landed__car",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("b", {
                                                                children: e.car
                                                            }),
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            /*#__PURE__*/ _jsxs("span", {
                                                                className: "mk-landed__car-frame",
                                                                children: [
                                                                    e.frame,
                                                                    " · ",
                                                                    e.note
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: e.ev
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-landed__rate",
                                                        children: e.rate
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: e.duty
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: e.mpf
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: e.hmf
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "mk-landed__strong",
                                                        children: e.total
                                                    })
                                                ]
                                            }, e.frame)),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mk-landed__tr mk-landed__tr--total",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-landed__car",
                                                    children: "Entry total"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$16,901"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {}),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$3,948.15"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$58.55"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$21.13"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "$4,027.83"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mk-landed__footnote",
                                children: "The rates are whatever the broker filed for that entry. Tariffs on Japanese vehicles keep changing, so Right Hand DMS never assumes a rate. It reads them off the 7501 and adds them up."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("section", {
                    "data-screen-label": "Review checks",
                    children: /*#__PURE__*/ _jsxs(Container, {
                        className: "mk-landed__checks",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-landed__checks-copy",
                                children: [
                                    /*#__PURE__*/ _jsx(SectionLabel, {
                                        k: "検品",
                                        children: "Review checks"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "mk-landed__h2",
                                        children: "It flags what doesn’t add up before you apply it."
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mk-landed__body17",
                                        children: "When you apply a document, the app shows what it found and anything that looks off, like duty booked twice, a shared fee or a missing exchange rate. You can sort it out with your broker or agent before it lands on the car."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Card, {
                                shadow: "md",
                                className: "mk-landed__flags",
                                children: FLAGS.map((f)=>/*#__PURE__*/ _jsxs("div", {
                                        className: "mk-landed__flag",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: `mk-landed__sev mk-landed__sev--${f.sev}`,
                                                children: f.label
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-landed__flag-text",
                                                children: f.text
                                            })
                                        ]
                                    }, f.text))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductDetails, {
                    title: "Details that matter to an importer",
                    items: [
                        [
                            'Your exchange rate, from your paperwork',
                            'Yen amounts convert at the rate on the document or on your Wise transfer. The app never falls back to a default rate.'
                        ],
                        [
                            'Nothing split behind your back',
                            'A document books to the car it’s attached to, and a 7501 books only that car’s line.'
                        ],
                        [
                            'No estimates mixed in',
                            'If a document hasn’t arrived, its line shows as missing. Nobody guesses it.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    title: "Landed cost questions",
                    items: [
                        [
                            'Which documents does it recognise?',
                            'Agent and auction invoices, Wise transfers, bills of lading, customs broker invoices, CBP 7501 and 3461, export certificates, EPA and DOT forms, port, trucking and title receipts, and parts invoices.'
                        ],
                        [
                            'Can I add costs without a document?',
                            'Yes. Lines you type in are marked manual, so you can always tell them apart.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 07",
                    title: "Email: Fastmail & IMAP",
                    go: "郵便 →",
                    href: MKT.product('email')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
